import { render, staticRenderFns } from "./CompanyWiseJobPlacement.vue?vue&type=template&id=7d4f5a3e&scoped=true&"
import script from "./CompanyWiseJobPlacement.vue?vue&type=script&lang=js&"
export * from "./CompanyWiseJobPlacement.vue?vue&type=script&lang=js&"
import style0 from "./CompanyWiseJobPlacement.vue?vue&type=style&index=0&id=7d4f5a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f5a3e",
  null
  
)

export default component.exports